import { coreUrls } from '@/api/urls/core';

import { setApiOptions } from '@/utilities/services';

import { RequestResponseType } from '../../../../models';

import { api } from '@/api/client';
import { BrandType, CategoryBrandType, GetBrandsQueryParam, GetCategoryBrandsQueryParam } from '@/server/services/core/brand/models';
import { AxiosPromise } from 'axios';

export const getBrandsService = (queryParam?: GetBrandsQueryParam): AxiosPromise<RequestResponseType<BrandType[]>> => {
    const options = setApiOptions(coreUrls.getBrands, queryParam ? { queryParam } : undefined, false);
    return api({ ...options, method: 'GET' });
};

export const getCategoryBrandsService = (queryParam: GetCategoryBrandsQueryParam): AxiosPromise<RequestResponseType<CategoryBrandType[]>> => {
    const options = setApiOptions(coreUrls.getCategoryBrands, { queryParam }, false);
    return api({ ...options, method: 'GET' });
};
